import { render } from "./page-preloader.vue?vue&type=template&id=d73d56e0"
import script from "./page-preloader.vue?vue&type=script&lang=js"
export * from "./page-preloader.vue?vue&type=script&lang=js"
script.render = render

export default script